// Module
var code = "<cr-event-flyout data=\"flyoutData\"></cr-event-flyout> ";
// Exports
export default code;